module.exports = __webpack_public_path__ + "static/media/logo.081b1edc.svg";